import { useTranslation } from 'react-i18next';
import { ExceptionExpiredCode } from '@/components/biz/exception/expired-code';
import { StepEnablePasskey } from '@/components/biz/fido/step-enable-passkey';
import { StepAllDone } from '@/components/steps/step-all-done';
import { StepSetupPassword } from '@/components/steps/step-setup-password';
import { StepVerifyCode } from '@/components/steps/step-verify-code';
import { Flow } from '@/constants/flow';
import { useFlowStore } from '@/store/use-flow-store';
import { StepInputUserInfo } from './components/step-input-userinfo';

export default function RegisterPage() {
  const { flow } = useFlowStore();
  const { t } = useTranslation();

  return (
    <>
      {flow === Flow.REGISTER_STEP_INPUT_USERINFO && <StepInputUserInfo />}
      {flow === Flow.REGISTER_STEP_INPUT_CODE && <StepVerifyCode type="register" />}
      {flow === Flow.REGISTER_STEP_INPUT_PASSWORD && <StepSetupPassword type="register" />}
      {flow === Flow.REGISTER_STEP_ENABLE_PASSKEY && <StepEnablePasskey title={t('account_created_success_title')} />}
      {flow === Flow.REGISTER_STEP_ALL_DONE && <StepAllDone type="register" />}
      {flow === Flow.EXCEPTION_EXPIRED_CODE && <ExceptionExpiredCode type="register" />}
    </>
  );
}
